import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "children", "title", "id", "tooltipPlacement", "aria-label"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import { mergeCallbacks } from 'utils/ui';
import Button from 'components/Button';
import Tooltip from 'components/Tooltip';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx } from "react/jsx-runtime";
var TooltipButton = /*#__PURE__*/forwardRef(function (_ref, outerRef) {
  var as = _ref.as,
    _children = _ref.children,
    title = _ref.title,
    id = _ref.id,
    tooltipPlacement = _ref.tooltipPlacement,
    ariaLabel = _ref['aria-label'],
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Component = as || 'button';
  var tooltipId = useUniqueId(id ? "".concat(id.toString(), "-tooltip") : undefined);

  // Destructuring `iconOnly` and separately passing it into the
  // <Button> component below makes TS go crazy, so we reassign it like this:
  var isIconOnlyButton = otherProps.iconOnly;
  var useTitleAsDescription = !isIconOnlyButton && (Boolean(_children) || Boolean(ariaLabel));
  var descriptionId = useTitleAsDescription ? tooltipId : undefined;

  /*
   Warning!!! `Button` is currently not being properly typechecked.
   Comment out `otherProps` and `as` when making changes to check types 
  */
  if (!title && !isIconOnlyButton) {
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, otherProps), {}, {
      as: Component,
      ref: outerRef,
      id: id,
      "aria-label": ariaLabel,
      children: _children
    }));
  }

  /*
   Warning!!! `Button` is currently not being properly typechecked.
   Comment out `otherProps` and `as` when making changes to check types 
  */
  return /*#__PURE__*/_jsx(Tooltip, {
    delay: 250,
    content: isIconOnlyButton && !title ? _children : title,
    placement: tooltipPlacement,
    renderWhenClosed: Boolean(useTitleAsDescription),
    id: descriptionId,
    referenceRef: outerRef,
    children: function children(_ref2) {
      var ref = _ref2.ref,
        open = _ref2.open,
        close = _ref2.close;
      return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, otherProps), {}, {
        as: Component,
        id: id,
        ref: ref,
        onMouseEnter: mergeCallbacks(open, otherProps.onMouseEnter),
        onMouseLeave: mergeCallbacks(close, otherProps.onMouseLeave),
        onMouseDown: mergeCallbacks(close, otherProps.onMouseDown),
        onTouchStart: mergeCallbacks(open, otherProps.onTouchStart),
        onTouchEnd: mergeCallbacks(close, otherProps.onTouchEnd),
        onFocus: mergeCallbacks(open, otherProps.onFocus),
        onBlur: mergeCallbacks(close, otherProps.onBlur),
        "aria-label": useTitleAsDescription ? ariaLabel : title,
        "aria-describedby": descriptionId,
        children: _children
      }));
    }
  });
});
TooltipButton.displayName = 'TooltipButton';
export default TooltipButton;